import React, { useEffect, useRef, useState } from "react";
import { BitmapText, Container } from "@pixi/react";
import BasicTexture from "../../../Elements/Textures/BasicTexture";
import {
  animateTextCounter,
  calculateFontSize,
  formatToCustomLocale,
} from "../../../utilities";
import { AnimationSettings } from "../../../settings";

const JackpotDisplay = ({
  height,
  width,
  y,
  x,
  zIndex,
  value,
  name,
  dimensions,
}) => {
  const [fontSize, setFontSize] = useState(
    calculateFontSize(dimensions.width, 18, 12)
  );
  const textRef = useRef(null);
  const previousValue = useRef(value);
  const [styleKey, setStyleKey] = useState(0); // Force re-rendering

  useEffect(() => {
    const newFontSize = calculateFontSize(dimensions.width, 20, 12);
    if (newFontSize !== fontSize) {
      setFontSize(newFontSize);
      setStyleKey((prev) => prev + 1);
    }
  }, [dimensions.width, fontSize]);

  useEffect(() => {
    if (previousValue.current !== value && textRef.current) {
      animateTextCounter(
        textRef,
        previousValue.current,
        value,
        AnimationSettings.INCREMENT_DURATION,
        (animatedValue) => `${formatToCustomLocale(animatedValue)}`
      );
      previousValue.current = value;
    }
  }, [value]);

  return (
    <Container
      y={y}
      x={x}
      zIndex={zIndex}
      name="JackpotDisplay"
      sortableChildren
    >
      {/* Background Image */}
      <Container
        y={-8}
        x={0}
        sortableChildren
        zIndex={1}
        name="JackpotDisplayName"
      >
        <BasicTexture
          height={height / 3}
          width={width / 1.5}
          zIndex={1}
          textureName={`JACKPOT_${name?.toUpperCase()}`}
        />
      </Container>

      {/* Display Background */}
      <Container y={height / 2} x={0}>
        <BasicTexture
          height={height}
          width={width * 1.5}
          zIndex={zIndex}
          textureName="displayBackground"
        />

        {/* BitmapText with dynamically updated font size */}
        <BitmapText
          key={styleKey} // Force re-render on fontSize change
          text={`${formatToCustomLocale(previousValue.current)}`}
          anchor={0.5}
          style={{
            fontName: `jackpot-${name}`,
            fontSize: fontSize,
            fill: "#ffffff",
            fontWeight: "bold",
            align: "center",
          }}
          ref={textRef}
        />
      </Container>
    </Container>
  );
};

export default JackpotDisplay;
